import customFetch from "./axio";

export interface AgreementDocument {
  _id?: string;
  kind: string;
  guarantorType?: "personal" | "office";
  status: string;
  signer?: { name?: string; email?: string };
  signedDocumentUrl?: string;
  signedAt?: string;
  draftDocumentUrl?: string;
  offlineUpload?: { status?: "pending_review" | "approved" | "rejected"; rejectionReason?: string; uploadedAt?: string };
}
export interface RentAgreement {
  _id: string;
  status: string;
  documents: AgreementDocument[];
  completedAt?: string;
  renewalAcknowledgements?: Array<{ transaction: string | { _id?: string; id?: string }; acknowledgedAt: string | null }>;
}
export const rentErrorMessage = (error: any, fallback: string) =>
  error?.response?.data?.errors?.[0]?.message || error?.response?.data?.message || error?.message || fallback;

export async function getRentAgreement(id: string, signal?: AbortSignal): Promise<RentAgreement | null> {
  const response = await customFetch.get(`/rent/bookings/${encodeURIComponent(id)}/agreement`, { signal });
  if (response.data?.success === false) throw new Error(response.data.errors?.[0]?.message || response.data.message || "Could not load tenancy agreement.");
  return response.data?.data?.current || null;
}
export async function resendRentAgreement(id: string, document: string, guarantorType?: string) {
  const response = await customFetch.post(`/rent/agreements/${encodeURIComponent(id)}/resend`, { document, guarantorType });
  if (response.data?.success === false) throw new Error(response.data.errors?.[0]?.message || response.data.message || "Could not resend agreement.");
  return response.data.message || "Agreement email resent.";
}
export async function acknowledgeRentRenewal(id: string) {
  const response = await customFetch.post(`/rent/bookings/${encodeURIComponent(id)}/renewal-acknowledgement`, {});
  if (response.data?.success === false) throw new Error(response.data.errors?.[0]?.message || response.data.message || "Could not record acknowledgement.");
  return response.data.message || "Acknowledgement recorded.";
}
export async function uploadOfflineSignature(id: string, document: string, guarantorType: string | undefined, file: File) {
  const body = new FormData();
  body.append("document", document);
  if (guarantorType) body.append("guarantorType", guarantorType);
  body.append("file", file);
  const response = await customFetch.post(`/rent/agreements/${encodeURIComponent(id)}/offline-upload`, body);
  if (response.data?.success === false) throw new Error(response.data.errors?.[0]?.message || response.data.message || "Could not upload the signed document.");
  return { message: response.data.message || "Signed document uploaded.", agreement: response.data.data as RentAgreement };
}
